import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Map as MapIcon, Target, Database, User, Menu } from 'lucide-react';

const TABS = [
  { label: 'Mapa', icon: MapIcon, path: '/dashboard' },
  { label: 'Oportun.', icon: Target, path: '/opportunities' },
  { label: 'Intel', icon: Database, path: '/intel' },
  { label: 'Perfil', icon: User, path: '/profile' },
];

const BottomTabBar = ({ onMore }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  const Item = ({ label, Icon, active, onClick }) => (
    <button
      onClick={onClick}
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '3px',
        background: 'none',
        border: 'none',
        padding: '6px 2px',
        cursor: 'pointer',
        color: active ? '#00CEC9' : '#7a8290',
      }}
    >
      <Icon size={20} />
      <span style={{ fontSize: '10px', letterSpacing: '0.3px', fontWeight: active ? 700 : 400 }}>
        {label}
      </span>
    </button>
  );

  return (
    <nav
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: '60px',
        paddingBottom: 'env(safe-area-inset-bottom)',
        display: 'flex',
        alignItems: 'stretch',
        backgroundColor: 'rgba(5,7,10,0.98)',
        borderTop: '1px solid #0B3D91',
        zIndex: 1200,
        backdropFilter: 'blur(6px)',
      }}
    >
      {TABS.map((t) => (
        <Item
          key={t.path}
          label={t.label}
          Icon={t.icon}
          active={isActive(t.path)}
          onClick={() => navigate(t.path)}
        />
      ))}
      <Item label="Más" Icon={Menu} active={false} onClick={onMore} />
    </nav>
  );
};

export default BottomTabBar;
